import { render } from "./PremiumDifferenceDialog.vue?vue&type=template&id=04072a5e"
import script from "./PremiumDifferenceDialog.vue?vue&type=script&lang=js"
export * from "./PremiumDifferenceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__